import {TOGGLE_MENU} from './types';

export const ToggleMenu = () => {
  return {type: TOGGLE_MENU}
}